import script from "./AllProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./AllProducts.vue?vue&type=script&setup=true&lang=js"

import "./AllProducts.vue?vue&type=style&index=0&id=864ee798&lang=css"

const __exports__ = script;

export default __exports__